/* Greek Superherbs — homepage interactions (Shopify port)
   Idempotent: safe to load once per section and re-run on Theme Editor section reloads. */
(function () {
  if (window.__gsxHome) return;
  window.__gsxHome = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.remove('no-js');

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* Scroll reveals */
  var io = null;
  if ('IntersectionObserver' in window && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }
  function reveals(root) {
    root.querySelectorAll('.gsx-reveal:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* Hero parallax (subtle) */
  function hero(root) {
    root.querySelectorAll('.gsx-hero__media img').forEach(function (img) {
      if (!once(img, 'gsxInit') || reduce) return;
      var raf = 0;
      var move = function () {
        raf = 0;
        var y = Math.min(window.scrollY, 900);
        img.style.transform = 'translate3d(0, ' + (y * 0.18) + 'px, 0) scale(' + (1 + y * 0.00008) + ')';
      };
      window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(move); }, { passive: true });
      move();
    });
  }

  /* Benefit finder tabs */
  function finder(root) {
    root.querySelectorAll('[data-gsx-finder]').forEach(function (box) {
      if (!once(box, 'gsxInit')) return;
      var tabs = Array.prototype.slice.call(box.querySelectorAll('.gsx-finder__tab'));
      var panels = Array.prototype.slice.call(box.querySelectorAll('.gsx-finder__panel'));
      var select = function (tab) {
        tabs.forEach(function (t) { var on = t === tab; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
        panels.forEach(function (p) { var on = p.id === tab.getAttribute('aria-controls'); p.classList.toggle('is-active', on); p.hidden = !on; });
      };
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var j = null;
          if (e.key === 'ArrowRight') j = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') j = 0;
          if (e.key === 'End') j = tabs.length - 1;
          if (j !== null) { e.preventDefault(); tabs[j].focus(); select(tabs[j]); }
        });
      });
    });
  }

  /* Horizontal strip arrows */
  function strips(root) {
    root.querySelectorAll('[data-gsx-strip]').forEach(function (wrap) {
      if (!once(wrap, 'gsxInit')) return;
      var strip = wrap.querySelector('.gsx-strip');
      if (!strip) return;
      var step = function () { return strip.firstElementChild ? strip.firstElementChild.getBoundingClientRect().width + 20 : 260; };
      var prev = wrap.querySelector('[data-strip-prev]');
      var next = wrap.querySelector('[data-strip-next]');
      if (prev) prev.addEventListener('click', function () { strip.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { strip.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    });
  }

  /* FAQ accordion */
  function faq(root) {
    root.querySelectorAll('[data-gsx-faq]').forEach(function (list) {
      if (!once(list, 'gsxInit')) return;
      var items = Array.prototype.slice.call(list.querySelectorAll('.gsx-faq__item'));
      items.forEach(function (item) {
        var btn = item.querySelector('.gsx-faq__q');
        var body = item.querySelector('.gsx-faq__a');
        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          items.forEach(function (o) {
            if (o !== item && o.classList.contains('is-open')) {
              o.classList.remove('is-open');
              o.querySelector('.gsx-faq__q').setAttribute('aria-expanded', 'false');
              o.querySelector('.gsx-faq__a').style.height = '0px';
            }
          });
          item.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', String(!open));
          body.style.height = open ? '0px' : body.firstElementChild.getBoundingClientRect().height + 'px';
        });
      });
    });
  }
  window.addEventListener('resize', function () {
    document.querySelectorAll('.gsx-faq__item.is-open .gsx-faq__a').forEach(function (b) {
      b.style.height = b.firstElementChild.getBoundingClientRect().height + 'px';
    });
  });

  /* Count-up numbers */
  var cio = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { runCount(en.target); cio.unobserve(en.target); } });
  }, { threshold: 0.4 }) : null;
  function runCount(el) {
    var target = parseFloat(String(el.dataset.count).replace(/[^0-9.]/g, ''));
    var dec = parseInt(el.dataset.decimals || '0', 10);
    if (isNaN(target)) return;
    if (reduce) { el.textContent = target.toFixed(dec); return; }
    var dur = 1400, t0 = performance.now();
    var tick = function (now) {
      var p = Math.min(1, (now - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec);
      if (p < 1) requestAnimationFrame(tick); else el.textContent = target.toFixed(dec);
    };
    requestAnimationFrame(tick);
  }
  function counters(root) {
    root.querySelectorAll('[data-count]').forEach(function (c) {
      if (!once(c, 'gsxInit')) return;
      if (cio) cio.observe(c); else runCount(c);
    });
  }

  /* Newsletter: native Shopify customer form; validate before submit */
  function newsletter(root) {
    root.querySelectorAll('[data-gsx-news]').forEach(function (form) {
      if (!once(form, 'gsxInit')) return;
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('input[type="email"]');
        if (!input.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value)) {
          e.preventDefault(); input.focus(); input.style.borderColor = '#b3261e'; return;
        }
        input.style.borderColor = '';
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = btn.dataset.busy || btn.textContent; }
      });
    });
  }

  /* Film: play only when visible */
  function film(root) {
    root.querySelectorAll('.gsx-film video').forEach(function (video) {
      if (!once(video, 'gsxInit') || !('IntersectionObserver' in window)) return;
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { video.play().catch(function () {}); } else { video.pause(); } });
      }, { threshold: 0.25 });
      vio.observe(video);
    });
  }

  /* Four islands: pinned photo crossfades with the chapter in view */
  function islands(root) {
    root.querySelectorAll('[data-gsx-islands]').forEach(function (wrap) {
      if (!once(wrap, 'gsxInit')) return;
      var chapters = wrap.querySelectorAll('[data-isl-ch]');
      if (!chapters.length) return;
      function activate(i) {
        wrap.querySelectorAll('[data-isl-pic],[data-isl-legend],[data-isl-dot],[data-isl-ch]').forEach(function (el) {
          var k = el.getAttribute('data-isl-pic') || el.getAttribute('data-isl-legend') || el.getAttribute('data-isl-dot') || el.getAttribute('data-isl-ch');
          el.classList.toggle('is-active', String(k) === String(i));
        });
      }
      if (!('IntersectionObserver' in window)) { activate(0); return; }
      var ratios = {};
      var iio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { ratios[en.target.getAttribute('data-isl-ch')] = en.isIntersecting ? en.intersectionRatio : 0; });
        var best = null, bestR = -1;
        Object.keys(ratios).forEach(function (k) { if (ratios[k] > bestR) { bestR = ratios[k]; best = k; } });
        if (best !== null && bestR > 0) activate(best);
      }, { rootMargin: '-35% 0px -35% 0px', threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] });
      chapters.forEach(function (c) { iio.observe(c); });
      wrap.querySelectorAll('[data-isl-dot]').forEach(function (d) {
        d.addEventListener('click', function () {
          var t = wrap.querySelector('[data-isl-ch="' + d.getAttribute('data-isl-dot') + '"]');
          if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    reveals(root); hero(root); finder(root); strips(root); faq(root); counters(root); newsletter(root); film(root); islands(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme Editor: sections are re-rendered live */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest && e.target.closest('.gsx-finder__panel');
    if (tab) {
      var box = tab.closest('[data-gsx-finder]');
      var btn = box && box.querySelector('[aria-controls="' + tab.id + '"]');
      if (btn) btn.click();
    }
  });
})();
